/**
 * extract string like opc.tcp://192.168.0.1:4840/Machine to just IP and port
 */
export function getIpPort(input: string): string {
  const url = input.includes("://") ? input : `opc.tcp://${input}`;
  const urlParts = url.split("//")[1];
  const firstSlashIndex = urlParts.indexOf("/");
  const ipPort =
    firstSlashIndex !== -1 ? urlParts.substring(0, firstSlashIndex) : urlParts;
  const ipPortParts = ipPort.split(":");

  if (ipPortParts.length > 2) {
    const port = ipPortParts.pop();
    const ip = ipPortParts.join(":");
    if (!isNaN(parseInt(port, 10))) {
      return `${ip}:${port}`;
    }
    return ip;
  } else if (ipPortParts.length === 2 && !isNaN(parseInt(ipPortParts[1], 10))) {
    return ipPortParts.join(":");
  }

  return ipPortParts[0];
}
